module.exports = __webpack_public_path__ + "static/media/3.Interlusion.80f71652.mp3";